module.exports = __webpack_public_path__ + "static/media/talapia.89088f28.jpg";